import { render, staticRenderFns } from "./footerName.vue?vue&type=template&id=4411cfff&scoped=true"
var script = {}
import style0 from "./footerName.vue?vue&type=style&index=0&id=4411cfff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4411cfff",
  null
  
)

export default component.exports